export const PROVIDER_URL = {
  mainnet: 'https://bsc-dataseed1.binance.org/',
  testnet: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
}

export const XCADToken = {
  tokenName: 'XCAD',
  tokenSymbol: 'XCAD',
  decimals: 18,
  img: '/assets/icons/token/xcad.svg',
  claimable: false,
  // c14AssetId: 'cfc04c20-5c15-4092-9800-efdfc3d05a8a',
  static: true,
  address: {
    bnb: {
      mainnet: '0xa026Ad2ceDa16Ca5FC28fd3C72f99e2C332c8a26',
      testnet: '0xCfD9F58d0E9F035890DB489B9785d5c230Da01Ba',
    },
    zil: {
      mainnet: '0x153FeaddC48871108e286de3304B9597c817B456',
      testnet: '0x17c81253b9DE207C98381c0ca3C84f2d151928c7',
    },
    opbnb: {
      testnet: '0x0bd208c45b74c89e0b196a80f1175c8f824c3f60',
      mainnet: '0xAF9fE3B5cCDAe78188B1F8b9a49Da7ae9510F151',
    },
  },
}
